import type { InputHTMLAttributes } from "react";

import styles from "./kit.module.css";

/**
 * One editable cell in a grid.
 *
 * Two modes, because a grid is used for two opposite jobs.
 *
 * By default it looks like the cell until touched: a wall of visible boxes reads as
 * a form to be filled in, and a grid of plain values reads as data that can be
 * corrected — which is what an import preview is.
 *
 * `boxed` is the other job. An *entry* grid starts empty, and an empty grid of
 * invisible boxes shows nothing at all: there is no data to read, so the only thing
 * on screen is a hint no wider than the word it contains. Where there is nothing to
 * correct, the box has to be the affordance.
 *
 * `bad` marks a cell the server objected to. The row keeps its place in the file
 * rather than being lifted out to an error list, so a problem is fixed where it is
 * instead of being hunted for.
 */
export function Cell({
  bad,
  boxed,
  title,
  ...rest
}: InputHTMLAttributes<HTMLInputElement> & { bad?: boolean; boxed?: boolean }) {
  return (
    <td className={bad ? styles.cellBad : undefined} title={title}>
      <input
        className={boxed ? `${styles.cellInput} ${styles.cellBoxed}` : styles.cellInput}
        aria-invalid={bad}
        {...rest}
      />
    </td>
  );
}
